import { Outlet, useLocation, useOutletContext } from 'react-router';
import './Homepage.scss';
import { setLogout } from '../reducer/authentication';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { API_URL } from '../config/constants';
import membersIconImg from '../images/membersIcon.png';
import membersIconDisImg from '../images/membersIconDisabled.png';
import dataIconImg from '../images/dataIcon.png';
import dataIconDisImg from '../images/dataIconDisabled.png';
import dataStructureIconImg from '../images/dataStructureIcon.png';
import dataStructureIconDisImg from '../images/dataStructureIconDisabled.png';
import activatedTreeIconImg from '../images/activated-treeIcon.png';
import notActivatedTreeIconImg from '../images/not-activated-treeIcon.png';
import psIconImg from '../images/psIcon.png';
import psIconDisImg from '../images/psIconDisabled.png';
import logoImg from '../images/logo.png';
import defaultProfilePic from '../images/profilePic.png';
import { useContext, useEffect, useState } from 'react';
import { ConfirmContext } from './components/ConfirmModal';
import { Link } from 'react-router-dom';
import Footer from './components/Footer';
import Loading from './components/Loading';
import useAsync from '../hooks/useAsync';

function Homepage() {

    const dispatch = useDispatch();
    const { confirm } = useContext(ConfirmContext);
    const onLogout = () => dispatch(setLogout());
    const onClick = async (e) => {
        e.preventDefault();
        const result = await confirm("로그아웃 하시겠습니까?", "네", "아니오");
        if (result) {
            onLogout()
            return await axios.post(`${API_URL}/monitoring-manage/logoutManagePage`).then((_) => {
                // window.location.href = '/';
            }).catch(e => { console.error(e) });
        } else {
            return false;
        }
    };

    const location = useLocation();
    const { pathname } = location;
    const [isOn, setIsOn] = useState('');
    const { userName, userRank, privilege } = useSelector((state) => state.session);
    useEffect(() => {
        const routeName = pathname.split('/')[2];
        setIsOn(routeName);
    }, [pathname])

    const hideStatistic = userRank > 1
    console.log("statistic.read =", privilege?.statistic?.read, privilege);
    console.log(privilege)
    return (
        <div className='container'>
            <div className="mainPage">
                <nav className="sideBar">
                    <Link to='/home/members' className='membersBtn' disabled={userRank !== 1 && userRank !== 2}>
                        <img src={isOn === "members" && (userRank === 1 || userRank === 2) ? membersIconDisImg : membersIconImg} alt="members" />
                        <span className='hint'>회원 관리</span>
                    </Link>
                    <ul>
                        <li>
                            <Link to='/home/processStatus' className='processStatusBtn'>
                                <img src={isOn === "processStatus" ? psIconDisImg : psIconImg} alt="processStatus" />
                                <span className='hint'>공정 상태</span>
                            </Link>
                        </li>
                        <li>
                            <Link to='/home/data/sumData' className='dataBtn'>
                                <img src={isOn === "data" ? dataIconDisImg : dataIconImg} alt="data" />
                                <span className='hint'>데이터 관리</span>
                            </Link>
                        </li>
                        <li>
                            <Link to='/home/dataStructure/sumData' className='dataStructureBtn' disabled={!privilege?.sumDataStruct?.read && !privilege?.detailedDataStruct?.read && !privilege?.sumDataView?.read && !privilege?.detailedDataView?.read && !privilege?.model?.read && !privilege?.userRank?.read}>
                                <img src={isOn === "dataStructure" ? notActivatedTreeIconImg : activatedTreeIconImg} alt="dataStructure" />
                                <span className='hint'>데이터 구조 관리</span>
                            </Link>
                        </li>
                        <li>
                            <Link to='/home/statistic/summ_data' className={`statisticBtn ${hideStatistic ? 'hidden' : ''}`}>
                            <img src={isOn === "statistic" ? dataStructureIconDisImg : dataStructureIconImg} alt="statistic" />
                                <span className='hint'>통계 분석</span>
                            </Link>
                        </li>

                        
                    </ul>
                </nav>
                <div className="contentArea">
                    <header>
                        <a href={'/home/processStatus'}>
                            <div className='homeBtnArea'>
                                <img src={logoImg} alt={"공정 모니터링 시스템"} />
                                <p>공정 모니터링 시스템</p>
                            </div>
                        </a>
                        <div className='myAccountArea'>
                            <Link to='/home/mypage'>
                                <div className='myAccount'>
                                    <img src={defaultProfilePic} alt={'내 정보'} />
                                    <p>
                                        {userName}님
                                    </p>
                                </div>
                            </Link>
                            <button onClick={onClick}>로그아웃</button>
                        </div>
                    </header>
                    <div className="content">
                        <Outlet />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Homepage;